<template>
  <div class="top-nav-wrap plr-110 flex f-14" :class="highLight ? 'c-99 bgc-F7': 'c-white bgc-primary'">
    <div class="top-nav-left flex-1">
      <span>欢迎访问凤质谷</span>
      <!-- <el-dropdown class="ml-20">
        <span class="el-dropdown-link pointer" :class="highLight ? 'c-blue': 'c-white'">【切换站点】</span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="jump"><a class="c-33" target="_blank" href="https://hzt.aihuaining.cn/">怀质通</a>
          </el-dropdown-item>
          <el-dropdown-item command="jump"><a class="c-33" target="_blank" href="http://61.132.228.201:11013/">天质通</a>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
    </div>
    <div class="top-nav-right flex-1 flex flex-jc-end">
      <template v-if="userType">
        <div class="pointer">{{username}}</div>
        <div class="ml-20 pointer" @click="toUserCenter">
          {{userType == 'user' ? '用户' : userType == 'org' ? '机构' : '哨点'}}中心</div>
      </template>
      <template v-else>
        <!-- <div class="pointer" @click="$router.push('/login')">登录</div> -->
        <div class="ml-20 pointer" @click="$router.push('/register')">平台用户注册</div>
        <div class="ml-20 pointer" @click="$router.push('/settled')">机构入驻</div>
      </template>
      <!-- <div class="ml-20">|</div>
      <div class="ml-20 flex flex-ai-center pointer">
        <img class="mini-icon" v-if="highLight" src="@/assets/images/layout/home_applets.png" alt="">
        <img class="mini-icon" v-else src="@/assets/images/layout/applets.png" alt="">
        <span class="ml-5">小程序</span>
      </div>
      <div class="ml-20 flex flex-ai-center pointer">
        <img class="service-icon" v-if="highLight" src="@/assets/images/layout/home_customerservice.png" alt="">
        <img class="service-icon" v-else src="@/assets/images/layout/customerservice.png" alt="">
        <el-dropdown @command="handleCommand">
          <span class="ml-5" :class="highLight ? 'c-99': 'c-white'">在线客服</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in customerList" :key="item.userId" :command="online(item)">
              {{item.userName}}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="ml-20 flex flex-ai-center pointer">
        <img class="phone-icon" v-if="highLight" src="@/assets/images/layout/home_telephone.png" alt="">
        <img class="phone-icon" v-else src="@/assets/images/layout/telephone.png" alt="">
        <span class="ml-5">热线电话：400-109-7887</span>
      </div> -->
    </div>
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  import { getCustomerUserList } from '@/api/modules/home'
  import { base64Encode,utf16to8 } from '@/utils/base64'
  
  export default {
    data(){
      return {
        customerList: []
      }
    },
    computed: {
      ...mapGetters([
        'userType',
        'username'
      ]),
      highLight() {
        return ['/login', '/index', '/beginner/index'].includes(this.$route.path)
      }
    },
    methods: {
      handleCommand(item) {
        item.command = Object.assign(item.command,{source: window.location.href})
        window.open('/modules/online-service?t='+base64Encode(utf16to8(JSON.stringify(item.command))),'_blank')
      },
      online(item){
        return {
          command: item
        }
      },
      toUserCenter() {
        switch (this.userType) {
          case 'user':
            this.$router.push('/user/entrust/index')
            break;
          case 'org':
            this.$router.push('/user/info/org')
            break;
          default:
            this.$router.push('/site/aide/report')
            break;
        }
      },
      getCustomerList() {
        getCustomerUserList().then(response => {
          this.customerList = response.data ? response.data : []
        }).catch(error => {

        })
      }
    },
    created() {
      this.getCustomerList()
    }
  }

</script>

<style lang="scss" scoped>
  .mini-icon {
    width: 10px;
    height: 17px;
  }

  .service-icon {
    width: 18px;
    height: 17px;
  }

  .phone-icon {
    width: 17px;
    height: 17px;
  }

</style>
